<template>
  <section :class="`lead-table ${theme.isDark ? 'lead-table_dark' : null}`">
    <b-table
      :data="leads"
      :columns="columns"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="numberPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      @click="handleClick"
      :row-class="(row, index) => (row.busy || row.type != 'life') && 'is-busy'"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    />
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "RawLeadTable",
  inject: ["theme"],
  props: {
    leads: Array,
  },
  data() {
    return {
      columns: [
        {
          field: "type",
          label: "Type",
          searchable: true,
          sortable: true,
        },
        {
          field: "fullname",
          label: "Full Name",
          searchable: true,
          sortable: true,
        },
        {
          field: "phone",
          label: "Phone",
          searchable: true,
          sortable: true,
        },
        {
          field: "email",
          label: "Email",
          searchable: true,
          sortable: true,
        },
        {
          field: "birth_date",
          label: "DOB",
          searchable: true,
          sortable: true,
        },
        {
          field: "updated",
          label: "Last Change",
          searchable: true,
          sortable: true,
        },
      ],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      perPage: 10,
    };
  },
  methods: {
    ...mapMutations({
      SET_CURRENT_PAGE: "leads/SET_CURRENT_PAGE",
    }),

    handleClick(payload) {
      if (payload.type == "life") {
        event.preventDefault();
        this.$router.push({ path: `/lead/${payload.id}` });
      }
    },

    rowClassHandler(row) {
      if (row.busy) return "is-busy";
      if (row.status == "notInterested") return "is-red";
      if (row.status == "doNotCall") return "is-red";
      if (row.status == "wrongPhoneNumber") return "is-red";
      if (row.status == "followUp") return "is-green";
      if (row.status == "thinkingAboutIt") return "is-orange";
      if (row.status == "inApplication") return "is-blue";
    },
  },
  computed: {
    ...mapGetters({
      currentPage: "leads/currentPage",
    }),
    numberPage: {
      get: function () {
        return this.currentPage;
      },
      set: function (number) {
        this.SET_CURRENT_PAGE(number);
      },
    },
  },
};
</script>
